(function() {
  'use strict';
  
  var COLOUR_NAMES = ['Black', 'Charcoal Grey', 'Light Grey', 'Olive Green', 'White', 'Navy Blue', 'Navy'];
  
  function initVariantImageFilter() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    if (gallery.dataset.sociaFilterInit === 'true') return;
    gallery.dataset.sociaFilterInit = 'true';
    
    function getSelectedColour() {
      var fieldsets = document.querySelectorAll('variant-radios fieldset.product-form__input');
      for (var i = 0; i < fieldsets.length; i++) {
        var fs = fieldsets[i];
        if (fs.className.toLowerCase().includes('option-name-color') || 
            fs.className.toLowerCase().includes('option-name-colour')) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          if (checked) return checked.value;
        }
      }
      
      var firstChecked = document.querySelector('variant-radios input[type="radio"]:checked');
      if (firstChecked && COLOUR_NAMES.indexOf(firstChecked.value) !== -1) {
        return firstChecked.value;
      }
      return null;
    }
    
    function filterByColour(colour) {
      if (!colour) return;
      var colourLower = colour.toLowerCase().trim();
      
      var mediaItems = document.querySelectorAll('.product__media-list .product__media-item');
      mediaItems.forEach(function(item) {
        var img = item.querySelector('img');
        if (!img) return;
        var altLower = (img.alt || '').toLowerCase().trim();
        if (altLower === colourLower) {
          item.style.display = '';
          item.removeAttribute('hidden');
        } else if (altLower && COLOUR_NAMES.map(function(c){return c.toLowerCase();}).indexOf(altLower) !== -1) {
          item.style.display = 'none';
          item.setAttribute('hidden', '');
        }
      });
      
      var thumbItems = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
      thumbItems.forEach(function(item) {
        var img = item.querySelector('img');
        if (!img) return;
        var altLower = (img.alt || '').toLowerCase().trim();
        if (altLower === colourLower) {
          item.style.display = '';
          item.removeAttribute('hidden');
        } else if (altLower && COLOUR_NAMES.map(function(c){return c.toLowerCase();}).indexOf(altLower) !== -1) {
          item.style.display = 'none';
          item.setAttribute('hidden', '');
        }
      });
      
      setTimeout(function() {
        var firstVisibleThumb = document.querySelector('.thumbnail-list .thumbnail-list__item:not([hidden]) button');
        if (firstVisibleThumb) {
          firstVisibleThumb.click();
        }
      }, 100);
    }
    
    function handleChange() {
      var colour = getSelectedColour();
      if (colour) filterByColour(colour);
    }
    
    document.querySelectorAll('variant-radios input[type="radio"]').forEach(function(input) {
      input.addEventListener('change', handleChange);
    });
    
    var variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', handleChange);
    }
    
    handleChange();
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVariantImageFilter);
  } else {
    initVariantImageFilter();
  }
  window.addEventListener('load', initVariantImageFilter);
  setTimeout(initVariantImageFilter, 500);
  setTimeout(initVariantImageFilter, 1500);
})();